<template>
	<div>
    <div class="mb-5">
      <router-link
          :to="issueLink"
          :target="openNewTab ? '_blank' : undefined"
      >
        <h2 class="text-xl font-bold text-gray-500 hover:underline">{{ article?.title }}</h2>
      </router-link>

      <h3 v-if="article?.subtitle" class="mt-2.5 text-base font-bold text-gray-500" v-html="article?.subtitle"></h3>
    </div>

		<div class="flex flex-wrap items-center justify-between gap-5 mb-5">
      <div class="flex-auto flex flex-wrap items-center gap-2">
        <router-link v-if="article?.meta?.pdf" :to="issueLink + '?scroll=issue'" class="flex items-center gap-1.5 px-2.5 py-1 text-xs text-gray-800 font-medium bg-gray-100 rounded-full">
          <font-awesome-icon icon="fa-solid fa-file-pdf" />
          <div>PDF</div>
        </router-link>

        <router-link v-if="article?.meta?.supplementum" :to="issueLink + '?scroll=issue'" class="flex items-center gap-1.5 px-2.5 py-1 text-xs text-gray-800 font-medium bg-gray-100 rounded-full">
          <font-awesome-icon icon="fa-solid fa-file-pdf" />
          <div>Supplementum</div>
        </router-link>

        <router-link v-if="article?.meta?.video" :to="issueLink + '?scroll=issue'" class="flex items-center gap-1.5 px-2.5 py-1 text-xs text-gray-800 font-medium bg-gray-100 rounded-full">
          <font-awesome-icon icon="fa-solid fa-video" />
          <div>Video Summary</div>
        </router-link>

        <router-link v-if="article?.meta?.live" :to="issueLink + '?scroll=issue'" class="flex items-center gap-1.5 px-2.5 py-1 text-xs text-gray-800 font-medium bg-gray-100 rounded-full">
          <font-awesome-icon icon="fa-solid fa-broadcast-tower" />
          <div>CH Live Interview</div>
        </router-link>
      </div>

			<div class="flex-auto overflow-hidden">
        <div class="flex justify-end">
          <div class="flex items-center gap-2">
            <div class="w-[12px] h-[28px]" :style="{ 'backgroundColor': props.article?.category?.meta?.color ?? '#000000' }"></div>
            <div class="text-xl font-bold" :style="{ 'color': article?.category?.meta?.color ?? '#000000' }">{{ article?.category?.name }}</div>
          </div>
        </div>

        <div v-if="article?.meta?.doi" class="text-right truncate mt-2">
          <a :href="'https://doi.org/' + article?.meta?.doi" class="text-xs font-medium text-ch-red hover:underline">{{ !article?.meta?.doi?.includes('DOI:') ? 'DOI: ' : '' }}{{ article?.meta.doi }}</a>
        </div>
			</div>
		</div>
		<div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 p-4 bg-gray-100 rounded-md">
      <div class="flex-auto">
        <div v-if="article?.leading_content" class="text-base font-medium text-gray-800" v-html="article?.leading_content"></div>
        <div v-if="article?.leading_content_2" class="text-sm font-medium text-gray-800 mt-2" v-html="article?.leading_content_2"></div>
      </div>
      <div v-if="previewImage" class="flex-none w-60 lightbox-enabled-container">
			  <img :src="previewImage" class="transition-all cursor-pointer graphical-abstract hover:scale-105" alt="Preview Image">
      </div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router';

const props = defineProps({
  article: {
    type: Object,
    required: true
  },
  openNewTab: {
    type: Boolean,
    default: false
  }
})

const route = useRoute()

const issueLink = computed(() => props.article?.page_path + '/' + props.article?.slug)

const livePosterUrl = computed(() => {
  const live = props.article?.meta?.live

  if (!live) return null

  const match = live.match(/\/players\/([^-]+)/);
  const mediaId = match?.[1];

  if (!mediaId) {
    return null
  }

  return 'https://cdn.jwplayer.com/v2/media/' + mediaId + '/poster.jpg'
})

const previewImage = computed(() => {
  // Check whether conditions are being met for showing the live (video) poster
  if (/^\/ch-live\/\d{4}-live-contents$/.test(route.fullPath) && livePosterUrl.value !== null) {
    return livePosterUrl.value
  } else { // Fallback to graphical_abstract image
    return props.article?.meta?.graphical_abstract
  }
})
</script>
